module.exports = "https://cdn.hellotech.com/client-assets/television-and-audio-mobile_f8439d4cf39d7aaa7cede06266d6c52b.jpg";